import AttachmentItemsPagingMetadata from 'owa-service/lib/contract/AttachmentItemsPagingMetadata';

export interface OneDriveProItemsSkipTokenPagingMetadata extends AttachmentItemsPagingMetadata {
    __type: 'OneDriveProItemSkipTokenPagingMetadata:#Client';
    skipToken: string;
    totalItemsFetched: number;
}

export function oneDriveProItemsSkipTokenPagingMetadata(
    metadata: Pick<
        OneDriveProItemsSkipTokenPagingMetadata,
        Exclude<keyof OneDriveProItemsSkipTokenPagingMetadata, '__type'>
    >
): OneDriveProItemsSkipTokenPagingMetadata {
    return { ...metadata, __type: 'OneDriveProItemSkipTokenPagingMetadata:#Client' };
}
